
import { useState } from 'react';

export default function ReviewsSection() {
  const [activeReview, setActiveReview] = useState(0);

  const reviews = [
    {
      id: 1,
      name: 'Carlos Mendoza',
      treatment: 'Cirugía Urológica de Próstata',
      rating: 5,
      comment: 'Excelente atención y profesionalismo. La cirugía fue un éxito total, me recuperé muy rápido y sin complicaciones. El Dr. es un verdadero experto.',
      source: 'Google',
      date: '2024-01-10'
    },
    {
      id: 2,
      name: 'María González',
      treatment: 'Tratamiento VPH',
      rating: 5,
      comment: 'El tratamiento con láser fue increíble. Sin dolor, sin cicatrices y resultados excelentes. El seguimiento ha sido perfecto. Muy recomendado.',
      source: 'Listados medicos ',
      date: '2024-01-08'
    },
    {
      id: 3,
      name: 'Roberto Silva',
      treatment: 'Cirugía Láser Urológica',
      rating: 5,
      comment: 'Procedimiento ambulatorio perfecto. Eliminaron mis cálculos renales sin ninguna molestia. La tecnología que maneja es impresionante.',
      source: 'Google',
      date: '2024-01-05'
    },
    {
      id: 4,
      name: 'Ana Martínez',
      treatment: 'Consulta Especializada',
      rating: 5,
      comment: 'Muy profesional y empático. Explicó todo el procedimiento detalladamente. Las instalacionesson excelentes.',
      source: 'Listados medicos ',
      date: '2024-01-03'
    },
    {
      id: 5,
      name: 'Luis Hernández',
      treatment: 'Disfunción Eréctil',
      rating: 5,
      comment: 'Tratamiento discreto y efectivo. Los resultados superaron mis expectativas. El Dr. es muy comprensivo y profesional.',
      source: 'Google',
      date: '2023-12-28'
    },
    {
      id: 6,
      name: 'Patricia Ruiz',
      treatment: 'Cirugía Urológica de Riñón',
      rating: 5,
      comment: 'La cirugía robótica salvó mi riñón. Técnica impecable, recuperación rápida. Estoy muy agradecida con el Dr. y su equipo.',
      source: 'Listados medicos ',
      date: '2023-12-25'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Lo que Dicen Nuestros Pacientes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Testimonios reales de pacientes que han experimentado los beneficios 
            de nuestros tratamientos y cirugías.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4" style={{ backgroundColor: '#168B98' }}>
                    <i className="ri-user-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900">{reviews[activeReview].name}</h3>
                    <p className="text-sm text-gray-600">{reviews[activeReview].treatment}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="flex text-yellow-400 mr-2">
                    {[...Array(reviews[activeReview].rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill"></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-500">{reviews[activeReview].source}</span>
                </div>
              </div>
              
              <blockquote className="text-gray-700 text-lg leading-relaxed mb-6">
                "{reviews[activeReview].comment}"
              </blockquote>
              
              <div className="text-sm text-gray-500">
                {reviews[activeReview].date}
              </div>
            </div>
            
            <div className="flex justify-center mt-8 space-x-2">
              {reviews.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveReview(index)}
                  className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                    index === activeReview ? 'bg-gray-300' : 'bg-gray-300'
                  }`}
                  style={{ backgroundColor: index === activeReview ? '#168B98' : '#d1d5db' }}
                />
              ))}
            </div>
          </div>
          
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-google-fill text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Google Reviews</h3>
                  <div className="flex items-center">
                    <div className="flex text-yellow-400 mr-2">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </div>
                    <span className="text-gray-600">5.0/5 (34 reseñas)</span>
                  </div>
                </div>
              </div>
              <p className="text-gray-600">
                Calificación perfecta basada en la experiencia de nuestros pacientes.
              </p>
            </div>
            
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mr-4" style={{ backgroundColor: '#168B98' }}>
                  <i className="ri-hospital-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Listados medicos </h3>
                  <div className="flex items-center">
                    <div className="flex text-yellow-400 mr-2">
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                      <i className="ri-star-fill"></i>
                    </div>
                    <span className="text-gray-600">5.0/5 (245+ reseñas)</span>
                  </div>
                </div>
              </div>
              <p className="text-gray-600">
                Calificación perfecta en listados médicos por excelencia y atención al paciente.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
